// @core/api/endpoints/landing/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ArchiveLandingPage } from './archive_landing_page';
import { CreateLandingPage } from './create_landing_page';
import { CreateLandingTemplate } from './create_landing_template';
import { DeleteLandingPage } from './delete_landing_page';
import { DuplicateLandingPage } from './duplicate_landing_page';
import { GetLandingAnalytics } from './get_landing_analytics';
import { GetLandingPage } from './get_landing_page';
import { GetLandingPageBySlug } from './get_landing_page_by_slug';
import { GetLandingTemplate } from './get_landing_template';
import { InstallLandingTemplate } from './install_landing_template';
import { ListLandingPages } from './list_landing_pages';
import { ListLandingTemplates } from './list_landing_templates';
import { PublishLandingPage } from './publish_landing_page';
import { UpdateLandingPage } from './update_landing_page';
import { UpdateSections } from './update_sections';

// Re-export individual endpoints
export {
  ArchiveLandingPage,
  CreateLandingPage,
  CreateLandingTemplate,
  DeleteLandingPage,
  DuplicateLandingPage,
  GetLandingAnalytics,
  GetLandingPage,
  GetLandingPageBySlug,
  GetLandingTemplate,
  InstallLandingTemplate,
  ListLandingPages,
  ListLandingTemplates,
  PublishLandingPage,
  UpdateLandingPage,
  UpdateSections,
};

// Namespace export for convenient usage
export const landingApi = {
  ArchiveLandingPage,
  CreateLandingPage,
  CreateLandingTemplate,
  DeleteLandingPage,
  DuplicateLandingPage,
  GetLandingAnalytics,
  GetLandingPage,
  GetLandingPageBySlug,
  GetLandingTemplate,
  InstallLandingTemplate,
  ListLandingPages,
  ListLandingTemplates,
  PublishLandingPage,
  UpdateLandingPage,
  UpdateSections,
};
